import { Routes } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { postLoginRedirectGuard } from './shared/utils/auth/post-login-redirect.guard';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: 'home',
                title: 'Home',
                loadComponent: () =>
                    import('./features/home/home.component').then((mod) => mod.HomeComponent),
            },
            {
                path: 'landing',
                canActivate: [OktaAuthGuard, postLoginRedirectGuard],
                children: [],
            },
            {
                path: 'customers',
                canActivate: [OktaAuthGuard],
                canActivateChild: [OktaAuthGuard],
                data: { breadcrumb: 'Customers' },
                loadChildren: () =>
                    import('./features/customers/customer.routes').then((x) => x.customerRoutes),
            },
            {
                path: 'services',
                canActivate: [OktaAuthGuard],
                canActivateChild: [OktaAuthGuard],
                data: { breadcrumb: 'Services' },
                loadChildren: () =>
                    import('./features/services/services.routes').then((x) => x.servicesRoutes),
            },
        ],
    },
    {
        path: 'login/callback',
        loadComponent: () =>
            import('./shared/components/auth-callback/auth-callback.component').then(
                (m) => m.AuthCallbackComponent
            ),
    },
    {
        path: '**',
        redirectTo: 'home',
    },
];
